<template>
    <div class="section7">
        <transition name="fade">
            <booking :action="2" :i18n="i18n" @openyySuccess="$emit('openyySuccess')" v-if="firstin" ref="booking2"/>
        </transition>
        <div class="footer" v-if="firstin">
            <div class="logos">
                <img class="logo1" src="@/assets/zh/7-1/7_1logo1.png" alt="">
                <img class="logo2" src="@/assets/zh/7-1/7_1logo2.png" alt="">
            </div>
            <div class="links">
                <a href="https://chuang-games.com/mlbb-useragreement-cn.html" target="_blank">{{ i18n('termsOfService') }}</a>
                <a href="https://chuang-games.com/mlbb-privacypolicy-cn.html" target="_blank">{{ i18n('privacyPolicy') }}</a>
            </div>
            <p class="copyright">&copy; SQUARE ENIX CHINA CO.,LTD. All Rights Reserved</p>
        </div>
    </div>
</template>
<script>
import booking from './booking.vue'
export default {
    props: ['language','i18n'],

    components: {
        booking,
    },
    data() {
        return {
            firstin: false,
        }
    },
    methods: {
        onFirstVisit() {
            this.firstin = true;
        },
        closeSelect2() {
            this.$refs.booking2.closeSelect()
        }
    }

}
</script>

<style lang="less" scoped>
.section7 {
    width: 100%;
    height: 100%;
    background: url(../../assets/zh/7-1/7_1bg.png) center 100% / cover no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    ::v-deep(.booking) {
        margin-top: -1rem;
    }
}
.footer {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 6.4rem;
    padding-bottom: .5rem;
    .logos {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
            width: auto;
        }
        .logo1 {
            height: .49rem;
        }
        .logo2 {
            height: .6rem;
        }
        .logo3 {
            height: .4rem;
        }
    }
    .links {
        margin-top: .6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        a {
            color: #fff;
            font-size: 0.18rem;
            &:nth-child(2) {
                margin-left: .46rem;
            }
            &:hover {
                color: #fff;
            }
        }
    }
    .copyright {
        font-size: .18rem;
        text-align: center;
        color: #fff;
        margin-top: 0.2rem;
    }
}

@media screen and (max-width: 751px) {
    ::v-deep .booking{
        padding: 0 0.9rem;
        width: 7.18rem;
        height: 7.4rem;
        background: url(../../assets/wap/zh/7-1/bg.png) 0 0 / 100% 100% no-repeat;
        &.en,
        &.in,
        &.th {
            height: 6.7rem;
        }
        &.fi {
            height: 7.4rem;
        }
        &::before {
            width: 6.61rem;
            height: .86rem;
            top: 0.5rem;
        }
        .s7-title {
            height: .8rem;
            margin: 0.3rem auto .4rem;
            max-width: 100%;
        }
        .w1 {
            font-size: .24rem;
            font-weight: 700;
            margin-bottom: .4rem;
        }
        .email {
            .email_ipt.email_ipt2 {
                width: 5.29rem;
                height: .7rem;
                flex: 1;
                text-align: center;
                padding: 0 0.4rem;
            }
            .yuyue2 {
                right: unst;
                left: 50%;
                transform: translateX(-50%);
                top: 3.7rem;
                &.en {
                    top: 2.6rem;
                }
                &.in,
                &.th {
                    top: 2.5rem;
                }
                &.fi {
                    top: 3.1rem;
                    font-size: .2rem;
                }
            }
        }
        .agree {
            font-size: .16rem;
            padding: 0 0.2rem;
            margin: 0;
        }
    }

}
</style>